module.exports = __webpack_public_path__ + "img/ProfilePic2.b8586e41.png";